import { CmsPageState } from '@boels/models';
import {
  getPage,
  loadPage,
  loadPageFail,
  loadPageSuccess,
  resetCmsPage,
  setActivePage,
} from '../actions/cms.actions';
import { createReducer, on } from '@ngrx/store';

export { CmsPageState };

const initialState: CmsPageState = {
  isCmsRoute: true,
  loading: false,
  entities: {},
  error: false,
  success: false,
  errorMessage: undefined,
  active: undefined,
  previousLabel: undefined,
};

export const reducer = createReducer(
  initialState,
  on(getPage, (state) => state),
  on(resetCmsPage, () => ({ ...initialState })),
  on(loadPage, (state) => ({
    ...state,
    loading: true,
    error: false,
  })),
  on(loadPageSuccess, (state, { culture, page, label }) => ({
    ...state,
    loading: false,
    error: false,
    success: true,
    entities: {
      ...state.entities,
      [culture]: {
        ...state.entities[culture],
        [label]: page,
      },
    },
    active: page,
    isCmsRoute: true,
  })),
  on(loadPageFail, (state, { errorMessage, label, previousLabel }) => ({
    ...state,
    loading: true,
    error: true,
    success: false,
    errorMessage,
    isCmsRoute: false,
    label,
    previousLabel,
  })),
  on(setActivePage, (state, { page }) => ({
    ...state,
    loading: false,
    error: false,
    success: true,
    active: page,
    isCmsRoute: true,
  })),
);
